import gql from 'graphql-tag';

export const MUTATION_INVOICE_NUMBER = gql`
  mutation MODIFY_INVOICE_NUMBER($input: UpdateCommissionInput) {
    updateCommission(input: $input) {
      result
    }
  }
`;
